<template>
  <div>
    <div class="master-badges" v-if="show">
      <div v-for="item in badges.all" :key="item.id" class="master-badge">
        <div class="main-checkbox">
          <input
            class="main-checkbox__input"
            type="checkbox"
            :id="`master-badge-${item.id}`"
            :value="item.id"
            v-model="masterBadges"
            :disabled="!$guard('write', 'Masters')"
          />
          <label :for="`master-badge-${item.id}`" class="main-checkbox__label">
            <svg
              width="14"
              height="11"
              viewBox="0 0 14 11"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M4.44912 8.6786L1.13019 5.25802L0 6.41462L4.44912 11L14 1.1566L12.8778 0L4.44912 8.6786Z"
                fill="#9BCD82"
              />
            </svg>
          </label>
        </div>

        <label class="master-badge__label" :for="`master-badge-${item.id}`">
          <img class="master-badge__icon" :src="item.icon" />
          <span v-text="item.name"></span>
        </label>
      </div>
    </div>

    <div class="main-form__buttons" v-if="show">
      <button
        class="main-button main-button_success main-button_mt22"
        @click="updateBadges"
        v-text="$t('global.save')"
        :disabled="maxLength || !$guard('write', 'Masters')"
        :class="{ disabled: maxLength }"
      ></button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
    name: 'badges',
    props: {
        dataUser: {
            required: true,
        },
    },
    data() {
        return {
            masterBadges: [],
            show: false,
        }
    },
    computed: {
        ...mapGetters({
            badges: 'badges/badges',
            masterBadgesCore: 'badges/masterBadges',
        }),
        isValid() {
            return true
        },
        maxLength() {
            return this.masterBadges.length > 4
        },
    },
    methods: {
        ...mapActions({
            saveBadges: 'badges/saveBadges',
            fetch: 'badges/fetch',
            fetchMasterBadges: 'badges/fetchMasterBadges',
        }),
        ...mapMutations({
            setMasterBadges: 'badges/setMasterBadges',
        }),
        updateBadges() {
            this.saveBadges({ badges: this.masterBadges, id: this.dataUser.id })
        },
    },
    async mounted() {
        await this.fetch()
        await this.fetchMasterBadges(this.dataUser.id)

        this.masterBadges = this.masterBadgesCore.map((item) => item.id)
        this.show = true
    },
}
</script>

<style lang="scss" scoped>
.master-badges {
  // border-top: 1px solid lightgrey;
  // margin-top: 20px;
  width: 100%;
  // height: 74vh;
  overflow-y: auto;
  display: flex;
  flex-wrap: wrap;

  p {
    color: #4d4d4d;
    font-family: "SFUIDisplay-Regular";
    font-size: 18px;
  }
}

.master-badge {
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  width: 40%;

  &__label {
    margin-top: 1px;
    cursor: pointer;
    user-select: none;
    display: flex;
    align-items: center;
    color: var(--list-color);
    font-size: 14px;
    line-height: 24px;
  }

  &__icon {
    margin: 0 8px 0 15px;
    width: 36px;
    height: 36px;
  }
}
</style>
